export default function CircularRightArrow({ style }) {
    return (
        <svg style={style} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 10.796C21 16.2061 16.5227 21 10.9999 21C5.47702 21 18.4609 17.5 18 10.796C17.4907 3.38802 6.31046 1 11.8333 1C17.3562 1 21 5.38587 21 10.796Z" fill="#83CFA4"/>
        <ellipse cx="11" cy="10.7959" rx="10" ry="9.79592" stroke="#536987" strokeWidth="1.5"/>
        <path d="M8.5 5.89844L13.5 10.7964L8.5 15.6944" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>      
    );
  }
  